import { AppDefinition } from '../../types/apps';

// These events should match the APP_ACTIONS registry
export const MEDIA_EVENTS = {
  OPEN: 'MEDIA_OPEN',
  ZOOM_IN: 'MEDIA_ZOOM_IN',
  ZOOM_OUT: 'MEDIA_ZOOM_OUT',
  RESET_ZOOM: 'MEDIA_RESET_ZOOM',
  ROTATE_LEFT: 'MEDIA_ROTATE_LEFT',
  ROTATE_RIGHT: 'MEDIA_ROTATE_RIGHT',
  PLAY: 'MEDIA_PLAY',
  PAUSE: 'MEDIA_PAUSE',
  TOGGLE_PLAYBACK: 'MEDIA_TOGGLE_PLAYBACK',
  SEEK: 'MEDIA_SEEK',
} as const;

export const ImageStudioAppDefinition: AppDefinition = {
  appId: 'imagestudio',
  name: 'Image Studio',
  version: '2.0.0',
  description: 'View images and videos. Open in Image Studio for AI-powered editing, generation, and compositing.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'FileImage',
    phosphorWeight: 'duotone',
    color: '#a855f7',
  },
  supportedFileTypes: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.mp4', '.webm', '.mov', '.avi', '.mkv'],
  events: MEDIA_EVENTS,
  entityTypes: ['Image', 'Video', 'File.Image', 'File.Video', 'ImageProject'],
  component: 'imagestudio',
  requiresProps: false,
  requiresEntity: true,
  isCore: true,
  entityIcons: {
    // Image types
    'Image': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image.JPEG': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image.JPG': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image.PNG': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image.GIF': { type: 'phosphor', phosphorIcon: 'ImageSquare', phosphorWeight: 'fill' },
    'File.Image.WebP': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    'File.Image.BMP': { type: 'phosphor', phosphorIcon: 'Image', phosphorWeight: 'fill' },
    // Video types
    'Video': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video.MP4': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video.WebM': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video.MOV': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video.AVI': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
    'File.Video.MKV': { type: 'phosphor', phosphorIcon: 'Video', phosphorWeight: 'fill' },
  }
};
